import { useContext } from 'react'
import { NotificationContext, notificationPush } from '../contexts'

interface IUseNotificationProps {
  notification: (text: string, color: string) => void
}
type UseNotificationProps = IUseNotificationProps

export const useNotification = (): UseNotificationProps => {
  const { notificationState, notificationDispatch } = useContext(NotificationContext)

  const notification = (text: string, color: string): void => {
    notificationPush(
      notificationDispatch,
      notificationState.notifications,
      text,
      parseInt((new Date().getTime() / 1000).toString()),
      4,
      color,
      false)
  }

  return {
    notification
  }
}
